// extracted by mini-css-extract-plugin
export default {"layout":"adOjuv","layoutContent":"bdOjuv"};